<div id="loader" class="d-flex justify-content-center">
    <div class="spinner-grow text-primary" role="status">
    </div>
</div>